import type { ThemeType } from '@/types/userType';

const localStorageThemeKey = 'ico-theme';
const defaultValue: ThemeType = 'light';

export const getLocalStorageTheme = () => {
    return (localStorage.getItem(localStorageThemeKey) as ThemeType) ?? defaultValue;
};

export const setLocalStorageTheme = (theme: ThemeType) => {
    if (theme === defaultValue) {
        localStorage.removeItem(localStorageThemeKey);
        return;
    }
    localStorage.setItem(localStorageThemeKey, theme);
};
